import {
  Form, Input, Select,
} from 'antd';

export default function ModalItem({ field }) {
  const {
    value, label, type, options, allowClear, rules, placeholder, prefix,
  } = field;
  return (
    <Form.Item
      name={value}
      label={label}
      key={value}
      rules={rules}
    >
      {type === 'input' && <Input prefix={prefix} />}
      {type === 'select' && <Select options={options} allowClear={allowClear} placeholder={placeholder} />}
    </Form.Item>
  );
}
